export const initExpiry = () => {
    const element = document.querySelector('.js-cart-expiry');
    if (!element) {
        console.log('no js-car-expiry')
        return
    }

    const server_expiry = element.dataset.expiry ? element.dataset.expiry : null ;
    const server_time = element.dataset.servertime ? element.dataset.servertime : null;

    const getAlertMessage = (locale) => {
        const messages = {
            'da-DK': 'Din kurv er udløbet',
            'de-DE': 'Ihr Warenkorb ist abgelaufen',
            'en-GB': 'Your cart has expired',
        };
        return messages[locale] || messages['da-DK'];
    };

    const expiry = server_expiry ? new Date(server_expiry * 1000) : null;
    console.log('Exp: ' + expiry);

    const now = server_time ? new Date(server_time * 1000) : null
    console.log('Now: ' + now);

    let expiryString = '0:00';

    if (!expiry || !now || isNaN(expiry.getTime()) || isNaN(now.getTime())) {
        console.log('im here')
        element.textContent = expiryString;
        return;
    }

    const intervalId = setInterval(() => {

        let remainingTime =  expiry.getTime() - now.getTime();
        let remainingTime_seconds = remainingTime / 1000;

        if (remainingTime > 0) {
            const minutes = Math.floor(remainingTime_seconds / 60);
            const seconds = ('0' + Math.floor(remainingTime_seconds % 60)).slice(-2);
            expiryString = `${minutes}:${seconds}`;
        } else {
            clearInterval(intervalId);
            const userLocale = document.documentElement.lang
            alert(getAlertMessage(userLocale));
            window.location.href = '/';
            return;
        }

        element.textContent = expiryString;
        now.setSeconds(now.getSeconds() + 1);

    }, 1000);
};
